/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_TitleInputs */

const en_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stronger every week.`)
};

const pl_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silniejszy co tydzień.`)
};

/**
* | output |
* | --- |
* | "Stronger every week." |
*
* @param {Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_title = /** @type {((inputs?: Hero_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_title(inputs)
	return en_hero_title(inputs)
});